$(function() {
    // Current Ajax request.
    // var currentAjaxRequest = null;
    // Grabbing all search forms on the page, and adding a .search-results list to each.
    var searchForms = $('form[action="/search"]').css('position','relative').each(function() {
        // Grabbing text input.
        var input = $(this).find('input[name="q"]');
        // Adding a list for showing search results.
        var offSet = input.position().top + input.innerHeight();
        $('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': offSet } ).appendTo($(this)).hide();
        $('<div class="search-close search-results-close"><i class="icon-cross"></i></div>').css( { 'position': 'absolute', 'right': '5px', 'top': '75px' } ).appendTo($(this)).hide();
        // Listening to keyup and change on the text field within these search forms.
        var searchingAdev;
        input.attr('autocomplete', 'off')
        input.bind('input', function() {
            var self = $(this)
            clearTimeout(searchingAdev);
            searchingAdev = setTimeout(function(){
                // What's the search term?
                var term = self.val();
                // alert(term)
                // What's the search form?
                var form = self.closest('form');
                // What's the search URL?
                var searchURL = '/search?type=product&q=' + term;
                // What's the search results list?
                var resultsList = form.find('.search-results');
                // If that's a new term and it contains at least 3 characters.
                
                if (term !== '') {
                    // Saving old query.
                    // self.attr('data-old-term', term);
                    // Killing any Ajax request that's currently being processed.
                    // if (currentAjaxRequest != null) currentAjaxRequest.abort();
                    // Pulling results.

                    resultsList.fadeIn(200);
                    resultsList.html('<li class="adev-no-results"><span class="title">Recherche pour "'+ term +'"...</span></li>');

                    $.ajax({
                        url: searchURL + '&view=json',
                        dataType: 'json',
                        type: 'GET'
                    })
                    .done(function (data) {
                        // Reset results.
                        console.log(data);
                        if(typeof data == "string") {
                            data = data.trim()
                        }
                        
                        // console.log(JSON.parse(data));
                        // If we have no results.
                        console.log(data.results_count);

                        if(data.results_count == 0) {
                            resultsList.html('<li class="adev-no-results"><span class="title">Aucun résultat trouvé pour "'+ term +'".</span></li>');
                            resultsList.fadeIn(200);
                            // resultsList.hide();
                            console.log('no results found');
                        } else {
                            // If we have results.
                            // $('.adev-no-results').remove()
                            resultsList.empty()
                            
                            

                            count=0;
                            let max_show = $(window).outerWidth() > 991 ? 9 : 6;
                            $.each(data.results, function(index, item) {

                                if(count < max_show){
                                    var link = $('<a></a>').attr('href', item.url);
                                    link.append('<span class="thumbnail image-hover-scale"><img src="' + item.thumbnail + '" /></span>');
                                    link.append('<span class="title">' + item.title + '</span>');
                                    link.wrap('<li></li>');
                                    resultsList.append(link.parent());
                                }
                                count++;
                            });

                            let headerHeight = $('[data-section-type="header-section"]').outerHeight() || 0;
                            let searchBar = $('.search_container_desktop .dropdn-content').outerHeight() || 0;
                            let maxHeight = 'calc(100vh - '+ (headerHeight + searchBar) +'px'
                            $('.search-results').css({
                                'max-height': maxHeight,
                                'overflow': 'hidden',
                                'overflow-y': 'auto',
                            })

                            // The Ajax request will return at the most 10 results.
                            // If there are more than 10, let's link to the search results page.
                            if(data.results_count > 9) {
                                resultsList.append('<li><span class="title"><a class="btn btn--alt" href="' + searchURL + '">Voir tous les résultats (' + data.results_count + ')</a></span></li>');
                            }

                            resultsList.fadeIn(200);
                            console.log('results showing');
                            console.log(resultsList);
                            $('.search-results-close').fadeIn(200);
                        }
                    })

                    // $.getJSON(searchURL + '&view=json', function(data) {
                        
                    // })
                }
            }, 300)
        })
    });
    // Clicking outside makes the results disappear.
    $('body').bind('click', function(){
        $('.search-results').hide();
          $('.search-results-close').hide();
    });
});